import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: '/', // Use relative URL so XHR patch in index.html can route to correct API
    withCredentials: true, // Include credentials (cookies) in all requests
    timeout: 30000 // 30 second timeout to prevent infinite hanging (especially important for member portal)
});

// Custom paramsSerializer - only apply when params contains arrays
// Use axios default serialization for non-array params
axiosInstance.interceptors.request.use((config) => {
    // Only modify GET requests with params that contain arrays
    if (config.method === 'get' && config.params && typeof config.params === 'object') {
        const hasArrays = Object.values(config.params).some(value => Array.isArray(value));

        if (hasArrays) {
            // Custom serialization for arrays - serialize as repeated params
            config.paramsSerializer = (params) => {
                if (!params || typeof params !== 'object') {
                    return '';
                }
                const parts = [];
                for (const key in params) {
                    if (params.hasOwnProperty(key)) {
                        const value = params[key];
                        if (Array.isArray(value)) {
                            // Serialize arrays as repeated params (e.g., studentIds=1&studentIds=2)
                            value.forEach(item => {
                                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
                            });
                        } else if (value !== null && value !== undefined) {
                            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
                        }
                    }
                }
                return parts.join('&');
            };
        }
        // If no arrays, let axios use default serialization (don't set paramsSerializer)
    }
    return config;
});

export default axiosInstance;